import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { measurementsActions } from '../../../../../store/slices/measurementsSlice/measurementsSlice';

export const useComment = () => {
    const dispatch = useDispatch();

    const { calculations } = useSelector((state) => state.measurementsReducer);

    const onInput = useCallback(
        (name, value) => {
            const changes = { [name]: value };
            dispatch(measurementsActions.changeCalculations(changes));
        },
        [calculations]
    );

    return { calculations, onInput };
};
